import { render, staticRenderFns } from "./ActivityDigestSummary.vue?vue&type=template&id=daf96bee&scoped=true&lang=html&"
import script from "./ActivityDigestSummary.vue?vue&type=script&lang=js&"
export * from "./ActivityDigestSummary.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDigestSummary.vue?vue&type=style&index=0&id=daf96bee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf96bee",
  null
  
)

export default component.exports